import { Pipe, PipeTransform } from '@angular/core';
import { LookupService } from '../services';

@Pipe({
  name: 'campaignDescription',
})
export class CampaignDescriptionPipe implements PipeTransform {
  constructor(private lookupSvc: LookupService) {}

  transform(campaignId: number) {
    return this.lookupSvc.campaignDescription$(campaignId);
  }
}
